import React, { useContext, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { xs_languageCode, systemCode } from '../..';
import { setFastbetCartEventListeners } from '../../betslip-observers';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import FastbetCartContext from '../../data/fastbet/FastbetCartContext';
import { ShopContext } from '../../data/shop/ShopConf';
import { getConfiguration, positionPopupSearchBoxFastbet, getBetDescription, getAggregationAndBetFromBetIdAndSportId, oddToString } from '../../data/utils';
import { getLabel } from '../../InitData';
import FastbetMatchSearchPopup from './FastbetMatchSearchPopup';

function FastbetCart(props) {
	const betslipContext = useContext(BetslipContext) ;
	const shopContext = useContext(ShopContext);
    const fastbetContext = useContext(FastbetCartContext);
    
    const eventSelector = React.useRef();
    const eventBetSelector = React.useRef();
    const conf = getConfiguration();
    const goToAmountFieldChar = conf.gtak;
    const fastbetType = fastbetContext.fastbetType;
    let matchFieldValue = fastbetContext.getMatchFieldText();

    // list of bets linked to the selected match
    let betList = fastbetContext.getBetList();
    betList = betList == null? [] : betList;
    matchFieldValue = matchFieldValue == null? "": matchFieldValue;

    useEffect(() => {
        if (betList?.length > 0 && window.eventsBuffer) {
            // If we're here it means that the user started typing before the data was loaded
            // and the typing stopped before the loading finished.
            // Now that the data is ready, we replay the keystrokes.
            const events = window.eventsBuffer;
            window.eventsBuffer = [];
            events.forEach(e => handleKeyDownBetAlias(e));
        }
    }, [betList]);
    
    useEffect(() => {
    	if(betslipContext.enableCustomAliases){
    		console.log("CUSTOMIZED ALIAS ENABLED!");    		
    	}
    }, [betslipContext.enableCustomAliases]);
    
    useEffect(function() {
    	let matchHasBeenSelected = fastbetContext.getSelectedMatch() != null;
   	 	if(matchHasBeenSelected){
   	 		// match has been selected: switching focus to the bet alias field
   	 		eventBetSelector.current.focus();
   	 	}
   	 	setFastbetCartEventListeners(shopContext.enabled? goToAmountFieldChar : null); // F2 and + or * listeners. Defined in betslip-observers	 
   });
    
   /* TYPE OF FASTBET AND HOW THEY WORK
    * 
    * XR (for retail use):
    *  - events are sorted in a map indexes by event alias. The user types an alias in the first input and "Enter": we take the event from the above map and retreive its data from
    *    the backend, in order to build the market autocomplete stuff (2th input)
    * AUTOCOMPLETE (for the final users):
    * - The user types something in the first input field. If what he typed is gt or equals than 3 chars, we generate an array
    *   of that events that are matching with the char inserted above, and we show a navigable popup (arrow up-down) to select one of them.
    *   On enter/click, we take the index of that event to retreive the data from the generated array, and to request the market stuff
    *   from the backend, in order to build the same market autocomplete data (2th input)
    * NONE:
    * - no fastbet function is enabled: no event field and no market field
    * 
    * */
    

    const betListToRender = [];
    const useCustomizedAlias = betslipContext.enableCustomAliases; 

    for(let k in betList){
    	let nativeBet = betList[k];	
    	const draws = [];
		const sportId = fastbetContext.selectedMatch.sportRef;
		let containerAggMarket = getAggregationAndBetFromBetIdAndSportId(sportId, nativeBet.cs, nativeBet.h);
		if(!containerAggMarket.aggregation && nativeBet.h != 0){
			containerAggMarket = getAggregationAndBetFromBetIdAndSportId(sportId, nativeBet.cs, 0);
		}
		if(containerAggMarket.market){
	    	let descBet = containerAggMarket.market.desc;
	    	if(containerAggMarket.market.hideHandicap){
	    		descBet = containerAggMarket.aggregation.descrizione;
	    	}
	    	else{
				descBet = getBetDescription({...nativeBet, ...containerAggMarket.market}, false, sportId);
			}
	    	for(let ke in nativeBet.eqs){
	    		const nativeDraw = nativeBet.eqs[ke];
	    		for(let kea in containerAggMarket.market.odds){
	    			const aggregateDraw = containerAggMarket.market.odds[kea];
	    			if(aggregateDraw.id == nativeDraw.ce){
	    				let odd = nativeDraw.q;
		    			if(nativeDraw.qps && nativeDraw.qps[systemCode]){
		    				odd = nativeDraw.qps;
		    			}
			    		if(odd > 100){
			    			const descDraw = containerAggMarket.market.hideHandicap? containerAggMarket.market.desc : aggregateDraw.desc;
				    		let aliasList = [];
				    		// checking if there is an alias customization for this skin
				    		if(useCustomizedAlias){
				    			let customizedAliasList = aggregateDraw.aliasBySystemCode? aggregateDraw.aliasBySystemCode[systemCode] : null;
				    			
				    			if((customizedAliasList == null || customizedAliasList.length === 0) && aggregateDraw.aliasHandicapBySystemCode){
				    				// searching it in the aliasByHandicapSystemCodeMap
				    				const keyMap = systemCode + "_" + nativeBet.h;
				    				customizedAliasList = aggregateDraw.aliasHandicapBySystemCode[keyMap];
				    			}
				    			if(customizedAliasList && customizedAliasList.length > 0){
				    				aliasList = customizedAliasList;
				    			}
				    		}
				    		else {
				
				    			if(aggregateDraw.aliasListDefault != null && aggregateDraw.aliasListDefault.length > 0){	
				    				aliasList = aggregateDraw.aliasListDefault;	
				        		}
				    			else if(aggregateDraw.aliasByHandicap != null && aggregateDraw.aliasByHandicap[nativeBet.h] != null){
				    				aliasList = aggregateDraw.aliasByHandicap[nativeBet.h];
				    			}
				    		}
			    			const draw = {
			    				odd,
			    				id : nativeDraw.ce,
			    				descDraw,
			    				aliasList
			    			};
				    		draws.push(draw);
			    		}
    				}
	    		}
	    	}
	    	if(draws.length > 0){
	    		let betRanking = 0;
	    		if(containerAggMarket.aggregation){
	    			betRanking = containerAggMarket.aggregation.ranking != null? containerAggMarket.aggregation.ranking : 0;
	    		}
	    		betRanking += containerAggMarket.market.ranking;
	    		const parsedBet = {
	    			scomSogei : nativeBet.cs,
	    			handicap : nativeBet.h,
	    			maxg : nativeBet.maxg,
	    			ming : nativeBet.ming,
	    			legabile: containerAggMarket.market.legabile,
	    			descBet,
	    			draws,
	    			ranking : betRanking
	    		};
	    		betListToRender.push(parsedBet);
	    	}		
		}
    }

    betListToRender.sort(function(betA, betB){
    	if(betA.ranking < betB.ranking) return -1;
    	if(betA.ranking > betB.ranking) return 1;
    	return 0;
    });
    
    // generating two maps:
    // 1) map of the match bets
    // 2) map of the draws, indexes by alias codes
    const betByIdMap = {};
    const oddsByAlias = {};
    const aliasByDrawId = {};
    const oddIndexByAlias = {};
    let index = 1;
    for(let kb in betListToRender){
    	const btr = betListToRender[kb];
    	betByIdMap[btr.scomSogei + "_" + btr.handicap] = btr;
    	for(let ko in btr.draws){
    		const draw = btr.draws[ko];
    		draw.index = index;
    		for(let ka in draw.aliasList){
    			const alias = draw.aliasList[ka].toLowerCase();
    			oddsByAlias[alias] = draw;
    			oddIndexByAlias[alias] = index;
    		}
    		const keyDraw = btr.scomSogei + "_" + btr.handicap + "_" + draw.id;
    		if(!aliasByDrawId[keyDraw]){
    			aliasByDrawId[keyDraw] = [];
    		}
    		aliasByDrawId[keyDraw].push({
    			alias:draw.aliasList,
    			bet : btr
    		});
    		index ++;
    	}
    }
	window.oddsByAlias = oddsByAlias;
    window.oddIndexByAlias = oddIndexByAlias;
    window.aliasByDrawId = aliasByDrawId;
    function handleKeyMatchField(event){
    	if(fastbetType === 'XR'){
    		// on KEY ENTER, if the alias exists, then select the linked match
    		if(event.key === "Enter"){
    			let alias = event.target.value;
    			if(alias.length > 0){
    				fastbetContext.setSelectedMatch(alias);
                    eventBetSelector.current.disabled = false;
                    eventBetSelector.current.focus();
    			}
    		}
    		else if((event.which == 187 || event.which == 107) && goToAmountFieldChar === "PLUS"){
    			window.switchFocusOnTheFirstAmountField();
    		}
    		else if((event.which == 106) && goToAmountFieldChar === "STAR"){
    			window.switchFocusOnTheFirstAmountField();
    		}
    		else if(event.which === 111){
    			clearCartAndFocusInMatchAlias();
    		}    		
    	}
    	else if(fastbetType === 'AUTOCOMPLETE') {
    		// handling enter code or arrow up/down to navigate over the result list
    		handleKeyUpAutocomplete(event);
    	}
    }
    

    

    function setMatchFieldValue(value){
    	if(fastbetType === 'XR'){
    		if(!isNaN(value)){
    			fastbetContext.setMatchFieldText(value);    		
    		}    		
    	}
    	else{
    		fastbetContext.setMatchFieldText(value);
    	}
    }
    
    const autocompleteSearchResults = fastbetContext.getAutocompleteSearchResults();
    
    const popupContainer =  document.getElementById('autocomplete-search-results-id-fastbet');
    if (popupContainer) {
        if (autocompleteSearchResults.length > 0) {
            if (popupContainer.style.top === '') {
                positionPopupSearchBoxFastbet(document.getElementById('fastbet-cart-event'), popupContainer);
            }
            popupContainer.style.display = '';
        } 
        else {
            popupContainer.style.display = 'none';
        }
    }
    

    
    let autocompleteResultHtml = null;
   
    function isMatchFocused(index){
    	if(fastbetContext.getMatchFocusedIndex() != null){
    		return fastbetContext.getMatchFocusedIndex() == index;
    	}
    	return false;
    }
    
    function selectMatchAutocomplete(index){
    	fastbetContext.setSelectedMatch(index);
    }
    
    const mapHtmlAutocompleteIndexWithSelectionIndex = {};
    
    function handleKeyUpAutocomplete(e){
		if(e.key === "Enter" && fastbetContext.getMatchFocusedIndex() != null){
			// select the focused match
			const realIndex = mapHtmlAutocompleteIndexWithSelectionIndex[fastbetContext.getMatchFocusedIndex()];
			if(realIndex !== null){
				fastbetContext.setSelectedMatch(realIndex);				
			}
		}
    	const arrowKey = e.which == 40 || e.which == 38;
    	if(!arrowKey){
    		return;
    	}
    	let newIndex = 0;
    	if(e.which == 40){
    		// keydown: ++
    		if(fastbetContext.getMatchFocusedIndex() != null){
    			newIndex = fastbetContext.getMatchFocusedIndex() + 1;    			
    		}
    		else{
    			newIndex = 0;
    		}
    		
    		if(newIndex == autocompleteSearchResults.length){
    			newIndex = 0;
    		}
    	}
    	else if(e.which == 38){
    		if(fastbetContext.getMatchFocusedIndex() != null){
    			newIndex = fastbetContext.getMatchFocusedIndex() - 1;    				
    		}
    		if(newIndex < 0){
    			newIndex = 0;
    		}
    	}
    	fastbetContext.setMatchFocusedIndex(newIndex);

    }
    
    if(autocompleteSearchResults.length > 0){

    	// creating a map indexes by sport_tournament to build the html result
    	const sportTournamentMap = {};
    	for(let ke = 0; ke < autocompleteSearchResults.length; ke++){
    		const match = autocompleteSearchResults[ke];
    		match.selectionIndex = ke; // saving the array index to allow the match selection
    		const keyMap = match.sportRef + "_" + match.tournamentRef;
    		if(!sportTournamentMap[keyMap]){
    			sportTournamentMap[keyMap] = {
    					description : match.sportDesc + " - " + match.tournamentDesc,
    					events : []
    			};
    		}
    		sportTournamentMap[keyMap].events.push(match);
    	}
    	
    	let htmlIndex = -1; // this variable keeps the index of the events sorted by sport_tournament, it could be different respect the full event list
    	autocompleteResultHtml = (
    			<ul>
    			{
    				Object.keys(sportTournamentMap).map(function(key){
    					const sportTournament =  sportTournamentMap[key];
    					return(
    							<React.Fragment key={key}>
	    							<li className="autocomplete-search-results-popup-title-2">{sportTournament.description}</li>
	    							{
	    								sportTournament.events.map(function(match){
	    									htmlIndex ++;
	    									// saving the link between htmlIndex  and selection Index
	    									mapHtmlAutocompleteIndexWithSelectionIndex[htmlIndex] = match.selectionIndex;
	    			    					return (
	    			                            <li key={match.pal + "_" + match.avv} 
	    			                            	className={"autocomplete-search-results-popup-title-3 pointer" + (isMatchFocused(htmlIndex)? " pointed" : "")}>
	    			                                <a href-disabled="#!" 
	    			                                   role="button" 
	    			                                   tabIndex="0" 
	    			                                   onClick={(e) => {selectMatchAutocomplete(match.selectionIndex)}}>
	    			                                	{match.alias} - {match.desc}
	    			                                </a>
	    			                            </li>
	    			    					)
	    			    				})
	    							}
    							</React.Fragment>
    							
    					)
    				})
    			}
    			</ul>
    	)
    }

    
    
    function handleFocus(){
    	if(fastbetContext.isInitialized()){
    		fastbetContext.removeMatch();    		
    	}
    	else{
    		fastbetContext.initialize();
    	}
    }
    


    
    
    // toggle the selected draw in the betslip
    function handleSelection(element){
    	const alias = element.value;
    	const values = alias.split("_");
    	// draw code
    	const drawCode = values.pop();
    	// handicap code
    	const handicap = values.pop();
    	// scom code
    	const scom = values.pop();
    	const bet = betByIdMap[scom + "_" + handicap];
  
    	if(bet != null){
    		let descDraw = drawCode;
    		let rawValue = null;
    		for(let k in bet.draws){
    			if(bet.draws[k].id == drawCode){
					descDraw = bet.draws[k].descDraw;
    				rawValue = bet.draws[k].odd;
    			}
    		}
    		if(rawValue){
	     		const event = fastbetContext.getSelectedMatch();
	    		betslipContext.toggleSelectionBetslip(event.pal, 
	    											  event.avv,
	    											  event.alias,
	    											  event.desc,
	    											  event.isLive,
	    											  scom, 
	    											  handicap, 
	    											  bet.descBet, 
	    											  drawCode,
	    											  descDraw,
	    											  rawValue,
	    											  bet.legabile,
	    											  event.sportDesc, 
	    											  event.tournamentDesc,
	    											  event.timestamp,
	    											  event.sportRef,
	    											  event.tournamentRef);   		
    		}

    		clearAliasBetBuffer();
    		eventSelector.current.focus();
    	}
    }
    
    
    
    function clearCartAndFocusInMatchAlias(){
		clearAliasBetBuffer();
		eventSelector.current.focus();
    	betslipContext.clearBetslip();
    }
    
    let aliasBuffer = "";
    
    function clearAliasBetBuffer(){
    	aliasBuffer = "";
    	const selectedIndex = eventBetSelector.current.selectedIndex;
		eventBetSelector.current.options[selectedIndex].selected = false;
		eventBetSelector.current.options[0].selected = true;
		clearTimeout(timeoutAliasOdd);
    }
    
    // handler of the keydown event on the bet alias field
    function handleKeyDownBetAlias(e) {
        if (betList.length === 0) {
            // The user is typing before the data has been loaded, so we save the keystrokes in a buffer
            if (window.eventsBuffer == null) {
                window.eventsBuffer = [];
            }
            e.persist();
            window.eventsBuffer.push(e);
            return;
        } else if (window.eventsBuffer?.length > 0) {
            // Before we process the current keystroke we need to replay the previous ones
            const events = window.eventsBuffer;
            window.eventsBuffer = [];
            events.forEach(e => handleKeyDownBetAlias(e));
        }
    	
    	if(e.key === "Enter"){
    		e.preventDefault();
    		// sends the draw into betslip
    		handleSelection(e.target);
    	}
    	else if(e.which === 111 && !useCustomizedAlias){
    		// char "/"
    		clearCartAndFocusInMatchAlias(); 
    	}
    	else{
    		const isSpaceBar = e.which == 32;
    		if(!isSpaceBar){
    			e.preventDefault();
    			
    			if (e.which < 48) {
			    	if(e.which == 8 || e.which == 46){
			    		// CANC key or BACK key: clear the buffer
			    		clearAliasBetBuffer();
			    	}
			    	return;
			    }
			    
		    	// key "*"  -> focus in the first avaialable amount field
    		    if(e.which == 106 && goToAmountFieldChar === "STAR"){
			    	// key "+" -> focus in the first avaialable amount field
			    	window.switchFocusOnTheFirstAmountField();
    		    	return; 
    		    }
    			
			    if((e.which == 187 || e.which == 107) && goToAmountFieldChar === "PLUS"){
			    	// key "+" -> focus in the first avaialable amount field
			    	window.switchFocusOnTheFirstAmountField();
			    	return; 
			    }

			    if ((e.which > 95) && (e.which < 106)) {
			    	//avaialable char codes
			    	aliasBuffer += String.fromCharCode(e.which - 48);
			    } 
			    else {
			        if ((e.which > 105) && (e.which < 112)) {
			        	//avaialable char codes
			        	aliasBuffer += String.fromCharCode(e.which - 64);
			        } 
			        else {
			        	//This is to grant the chars "+/-" in an alias code
			        	if(e.which == 189){
			        		// "minus" key near the SPACE bar: I force the 109 = minus. 
			        		let originalMinus = 109; 
			        		aliasBuffer += String.fromCharCode(originalMinus - 64);
			        	}
			        	else if(e.which == 187){
			        		// "plus" key near the P key: I force the 107 = plus
			        		let originalPlus = 107; 
			        		aliasBuffer += String.fromCharCode(originalPlus - 64);
			        	}
			        	else{
			        		//avaialable char codes
			        		aliasBuffer += String.fromCharCode(e.which);
			        	}      
			        }
			    }
			    
			    
			    if(aliasBuffer != ""){
			    	aliasBuffer = aliasBuffer.toLowerCase();
			    	console.log(aliasBuffer);
			    	// searching the odd with its alias
			    	if(oddIndexByAlias[aliasBuffer] != null){
			    		if(aliasBuffer == 'g12') debugger;
			    		const selectedIndex = eventBetSelector.current.selectedIndex;
			    		eventBetSelector.current.options[selectedIndex].selected = false;
			    		const newIndex = oddIndexByAlias[aliasBuffer];
			    		eventBetSelector.current.options[newIndex].selected = true;
			    	}
			    }
			    // setting a timeout: after 10 seconds, the buffer must be cleaned
			    clearTimeout(timeoutAliasOdd);
			    timeoutAliasOdd = setTimeout(clearAliasBetBuffer, 10000);
    		}
    	}
    }
    
    let timeoutAliasOdd = null;

    function openPdf(){
    	let link = conf.fbus[xs_languageCode];    	
    	if(link != null){
    		window.open(link, '_blank', 'location=yes,height=970,width=1020,scrollbars=yes,status=yes');    		
    	}
    }

    return <>
    		{
    			fastbetType === "NONE"?
    				(<></>)
    				:
    				(
    		    	<div className="fastbet bordato-widget-a fbet-unariga bordo-tondo widget bg-bianco padding-verticale padding-orizzontale margine-giu">
    		            {
		    		    <div className="alias-fastbet">
    		            	<i onClick={ openPdf } className="pointer fas fa-question-circle margine-dx-mezzo nero"></i>
    			            <input className="input-personalizzato" autoComplete='off'
    			            	   type="text" 
    			            	   id="fastbet-cart-event" 
    			            	   placeholder={fastbetContext.isLoading()? getLabel('general.loading') : getLabel('general.alias')}
    			            	   readOnly={!fastbetContext.isDataLoaded()}
    			            	   value={matchFieldValue}
    			            	   onChange={e => setMatchFieldValue(e.target.value + "") }
    			            	   onKeyUp={e => handleKeyMatchField(e)}
    			            	   onFocus={() => handleFocus()}
    			            	   ref={eventSelector} />
    		            </div>
    		            }

    		            <select onSelect={e => handleSelection(e.target)} 
    		            		onKeyDown={e => handleKeyDownBetAlias(e)} 
    		            		ref={eventBetSelector} 
    		            		disabled={betList.length === 0} 
    		            		className="custom-select">
    		            	<option value="-1">{getLabel('carrello.premi_spazio')} </option>
    			            {
    				        	Object.keys(betListToRender).map(function(key){
    				        		
    				        		const bet = betListToRender[key];
    				        		const draws = bet.draws;
    				        		const betReactKey = bet.scomSogei + "_" + bet.handicap;
    			       			 	return (
    			       		            <optgroup key={betReactKey} label={bet.descBet}>
    			       		            {	
    			       		            	Object.keys(draws).map(function(keyDraw){
    			       		            		const draw = draws[keyDraw]; 
    											const value = bet.scomSogei + "_" + bet.handicap  + "_" + draw.id;;
    			       		            		const index = draw.index;
    					       		        	 return(
    						       		        	 <option index={index}
    						       		        	 		 key={value} 
    						       		        	   		 value={value}
    						       		        	 		 id={"draw-alias-" + value}
    						       		        	 		 scom_sogei={bet.scomSogei}
    						       		        	 		 draw = {draw.id}
    						       		        	 		 handicap={bet.handicap}>
    						       		        	 	{draw.descDraw} : {oddToString(draw.odd)}
    						       		        	 </option>
    					       		        	 )
    					       		         })
    			       		            }
    			       	                </optgroup>
    			       			 	)
    			       		 	})
    			       	 	}
    		            </select>
    		        </div>
    			)
    		}
	<FastbetMatchSearchPopup />
	{
		autocompleteSearchResults.length > 0 && (ReactDOM.createPortal(autocompleteResultHtml, popupContainer))
	}
    </>

}


export default FastbetCart;